import React from 'react';
import { Header, Footer } from '../Common';
class EstimateDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            budget: ''
        }
        console.log(this.props.location.state)
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-4 pt-1"></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="request_confirm">
                            <div className="container">
                                <div className="request_confirm_align">

                                    <div className="request_confirm_text">
                                        <h2>
                                            Check The Content Of Consultation For Estimation And Customization
                                       </h2>
                                    </div>
                                    <div className="request_confirm_form">
                                        <div className="row">
                                            <div className="col-md-2 text-right" style={{ marginTop: '15px', marginLeft: '15px' }}>
                                                <img alt="" src={this.props.location.state.buyer_img} height="30%" width='100%' />
                                            </div>
                                            <div className="col-md-8 " style={{ marginTop: '15px', marginLeft: '15px' }}>
                                                <div className="request_title">
                                                    <h4> {this.props.location.state.buyer_name}</h4>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-3 ">
                                                        <div className="request_service_name">
                                                            Service Name
                                                        </div>
                                                    </div>
                                                    <div className="col-md-9">
                                                        {this.props.location.state.title}
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className="col-md-3">
                                                        <div className="request_service_name">
                                                            Deadline for Proposal
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 mt-2">
                                                        {this.props.location.state.date}
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="request_service_name">
                                                            Budget guide
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 mt-1">
                                                        {this.props.location.state.budget}
                                                    </div>
                                                </div>
                                                <div className="request_message mt-3">
                                                    {this.props.location.state.content}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />

            </div>
        )
    }
}

export { EstimateDetails }